import React from 'react';
import styled from '@emotion/styled';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';

export interface EntryCardValues {
  header?: string;
  subHeader?: string;
  ctaButton?: string;
  backgroundColor?: string;
  imageLink?: string;
  backgroundImage?: string;
}

interface PreviewEntryCardProps {
  values: EntryCardValues & any;
  isPreview?: boolean;
  height?: string;
  className?: string;
}

export const PreviewEntryCard = (props: PreviewEntryCardProps) => {
  const { values, isPreview, height, className } = props;
  const { header, subHeader, ctaButton, imageLink, backgroundImage } = values;

  const backgroundImageUrl = imageLink || backgroundImage;
  const isDefaultImage = !backgroundImageUrl || !isPreview;

  return (
    <StyledPreviewContainer height={height} className={className}>
      <div className="preview-ant-image">
        {!isDefaultImage ? (
          <>
            <img className="image-entry-card" src={backgroundImageUrl} alt="" />
            <div className="content-preview">
              {header && <StyledHeader>{header}</StyledHeader>}
              {subHeader && <StyledSubHeader>{subHeader}</StyledSubHeader>}
              {ctaButton && <StyledButton>{ctaButton}</StyledButton>}
            </div>
          </>
        ) : (
          <div className="image-default">
            <img src={UploadImage} alt="" />
            <div>Upload BG Image (optional)</div>
          </div>
        )}
      </div>
    </StyledPreviewContainer>
  );
};

const StyledPreviewContainer = styled.div<{ height?: string }>`
  ${appStyles.fullWidthHeight}
  height: ${props => props.height || '200px'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 16px;

  & .preview-ant-image {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff;

    & .image-entry-card {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    & .image-default {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      & img {
        width: 65px;
        height: 65px;
        margin-bottom: 10px;
        opacity: 0.6;
      }

      & div {
        font-size: 14px;
        font-weight: 700;
        color: #000;
      }
    }
  }

  & .content-preview {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }
`;

const StyledHeader = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
`;

const StyledSubHeader = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  margin: 0 0 16px 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
  opacity: 0.9;
`;

const StyledButton = styled.button`
  background-color: #fff;
  color: #000;
  border: none;
  border-radius: 24px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  text-transform: uppercase;

  &:hover {
    background-color: #333;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
